/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Session_ExpiredInputs */

const vi_error_shop_session_expired = /** @type {(inputs: Error_Shop_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên đăng nhập của khách đã hết hạn. Khách cần đăng nhập lại.`)
};

/**

* @param {Error_Shop_Session_ExpiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_session_expired = /** @type {((inputs?: Error_Shop_Session_ExpiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Session_ExpiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_session_expired(inputs)
});